import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';


const Rutas = ({ lang, rutasdestino, ruta, destino, propiedadesdestino }) => {

    const { t } = useTranslation();
    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        (destino.id !== 48 && destino.id !== 40) ? (
            <>
                <section className="skrollable u-align-center u-clearfix u-container-align-center-lg u-container-align-center-md u-container-align-center-sm u-container-align-center-xl u-image u-parallax u-section-3" id="block-14" data-image-width="1920" data-image-height="1080">
                    <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                        <h1 className="u-align-center u-text u-text-default u-text-white u-text-1">{t("Descubre cada ruta")}</h1>
                        <div className="botones-rutas">
                            {
                                rutasdestino.map((unaruta, indexr) => (
                                    <>
                                        <a href={"#ruta" + (indexr + 1)} data-page-id="308060012" className={"u-border-none u-btn u-btn-round u-button-style u-hover-custom-color-5 u-radius u-text-custom-color-5 u-text-hover-white u-white boton"} key={"r" + indexr}>{unaruta.nombre}</a>
                                    </>
                                ))
                            }
                        </div>
                    </div>
                </section>

                {
                    rutasdestino.map((unaruta, indexr) => (
                        <Fragment key={`unaruta-${indexr}`}>
                            <section className={`u-clearfix u-container-align-center-lg u-container-align-center-md u-container-align-center-sm u-container-align-center-xl ${indexr % 2 === 0 ? 'u-grey-5' : 'u-white-5'} u-section-4`} id={`ruta${indexr + 1}`}>
                                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                                    <div className="data-layout-selected u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-clearfix u-expanded-width u-gutter-0 u-layout-spacing-horizontal u-layout-wrap u-layout-wrap-1">
                                        <div className="u-gutter-0 u-layout">
                                            <div className="u-layout-col">
                                                <div className="u-size-60">
                                                    <div className="u-layout-row">
                                                        <div className="u-container-style u-layout-cell u-shape-rectangle u-size-60 u-layout-cell-1">
                                                            <div className="u-container-layout u-valign-bottom-xl u-valign-middle-lg u-valign-middle-sm u-container-layout-1">
                                                                <h2 className="u-align-center u-custom-font u-font-montserrat u-text u-text-default u-text-1">{unaruta.nombre}&nbsp;</h2>
                                                                <p className="u-align-center u-custom-font u-font-montserrat u-text u-text-2">{unaruta.descripcion_corta[lang]}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </Fragment>
                    ))
                }
                <section className="u-clearfix u-custom-color-11 u-section-7" id="block-15">
                    <div className="u-clearfix u-sheet u-sheet-1">
                        <a href={"/" + preidioma + t("contacto")} className="u-align-center u-border-hover-grey-60 u-border-none u-btn u-btn-round u-button-style u-hover-feature u-hover-white u-radius u-white u-btn-1" title="Solicitar propuesta personalizada">{t("Solicitar presupuesto").toUpperCase()}</a>
                    </div>
                </section>
            </>
        )
            : (destino.id == 40) ? (
                <>
                    {
                        rutasdestino.map((unaruta, indexr) => (
                            <Fragment key={`unaruta-${indexr}`}>
                                <section className={`u-clearfix u-container-align-center-lg u-container-align-center-md u-container-align-center-sm u-container-align-center-xl ${indexr % 2 === 0 ? 'u-grey-5' : 'u-white-5'} u-section-5`} id={`ruta${indexr + 1}`}>
                                    <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                                        <div className="data-layout-selected u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-clearfix u-expanded-width u-gutter-0 u-layout-spacing-horizontal u-layout-wrap u-layout-wrap-1">
                                            <div className="u-gutter-0 u-layout">
                                                <div className="u-layout-col">
                                                    <div className="u-size-60">
                                                        <div className="u-layout-row">
                                                            <div className="u-container-style u-layout-cell u-shape-rectangle u-size-60 u-layout-cell-1">
                                                                <div className="u-container-layout u-valign-bottom-xl u-valign-middle-lg u-valign-middle-sm u-container-layout-1">
                                                                    <h2 className="u-align-center u-custom-font u-font-montserrat u-text u-text-default u-text-1">{unaruta.nombre}&nbsp;</h2>
                                                                    <p className="u-align-center u-custom-font u-font-montserrat u-text u-text-2">{unaruta.descripcion_corta[lang]}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </Fragment>
                        ))
                    }
                    <section className="u-clearfix u-custom-color-11 u-section-7" id="block-15">
                        <div className="u-clearfix u-sheet u-sheet-1">
                            <a href={"/" + preidioma + t("contacto")} className="u-align-center u-border-hover-grey-60 u-border-none u-btn u-btn-round u-button-style u-hover-feature u-hover-white u-radius u-white u-btn-1" title="Solicitar propuesta personalizada">{t("Solicitar presupuesto").toUpperCase()}</a>
                        </div>
                    </section>
                </>
            )
                :
                (
                    <>
                        <section className="skrollable u-align-center u-clearfix u-container-align-center u-image u-parallax u-section-3" id="block-14" data-image-width="1920" data-image-height="1080">
                            <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
                                <h1 className="u-align-center u-text u-text-default u-text-white u-text-1">{t("Descubre Mallorca a bordo")}</h1>
                            </div>
                        </section>
                        <section className="u-clearfix u-custom-color-11 u-section-7" id="block-15">
                            <div className="u-clearfix u-sheet u-sheet-1">
                                <a href={"/" + preidioma + t("embarcaciones") + "-" + t("Destino").toLowerCase() + "-" + destino.laurl} className="u-align-center u-border-hover-grey-60 u-border-none u-btn u-btn-round u-button-style u-hover-feature u-hover-white u-radius u-white u-btn-1" title="Solicitar propuesta personalizada">{t("reserva").toUpperCase() + " " + t("Ahora").toUpperCase()}</a>
                            </div>
                        </section>
                    </>
                )
    )
}
export default Rutas;
